<template lang="pug">
  transition(name="fade")
    .Popup.col-2(
    @click="popupClose")

      transition(name="slide")
        .content(v-if="PAGE_SHOW")

          .header

            button.cancel(
            type="button"
            @click="close")
              IconClose

            h3.title.u-text-width-bold
              template(v-if="is_edit")
                | {{ $t('generic.action._edit', [$t('generic.field.goal.s')]) }}
              template(v-else)
                | {{ $t('generic.action._add', [$t('generic.field.goal.s')]) }}

            template(v-if="can_delete")
              button.btn.btn-small.btn-danger.right-btn(
              type="button"
              @click="openDeleteModal")
                Loading(v-if="$wait.is('deleteGoal')")
                span(v-else) {{ $t('generic.action.delete') }}

          .body

            .grid.grid-2-col
              FormItem(
                type="select"
                field_name="month"
                :label_text="$t('generic.dates.month')"
                select_label="name"
                track-by="name"
                :multiple="false"
                :options="monthList"
                v-model="goal.$month"
                :disabled="is_edit"
                :validate="true"
                :required="true"
                v-validate="'required'"
                :error="veeErrors.first('month')")
              FormItem(
                type="select"
                field_name="year"
                :label_text="$t('generic.dates.year')"
                select_label="name"
                track-by="name"
                :multiple="false"
                :options="yearList"
                v-model="goal.$year"
                :disabled="is_edit"
                :validate="true"
                :required="true"
                v-validate="'required'"
                :error="veeErrors.first('year')")

              FormItem.total-goal-input(
                type="currency"
                :label_text="'Hedef (TL)'"
                field_name="total_goal"
                :small="true"
                :validate="true"
                :hide_error_msg="true"
                v-model="goal.target_goal"
                :required="true"
                v-validate="'min_value:0'"
                min="0"
                :error="veeErrors.first('total-goal')")
              .category-tree
                label {{'Hedef Türü'}}
                .tree
                  CategoryTree(
                    :categories="categories"
                    :itemMode="categoryTreeItemMode"
                    @input="onCategoryChange"
                    :value="goal.category_ids"
                  )
          .footer
            button.cancel.btn.btn-line(
            type="button"
            @click="close"
            ) {{ $t('generic.action.cancel') }}

            button.save.btn.btn-primary(
            type="button"
            @click="save"
            :disabled="is_loading")
              Loading(v-if="is_loading")
              span(v-else) {{ $t('generic.action.save') }}

      Modal(
      v-if="show_delete_modal"
      :acceptText=" $t('generic.action.delete') "
      :denyText=" $t('generic.action.cancel')  "
      type="danger"
      :is_loading="$wait.is('deleteGoal')"
      @onAccept="onDelete"
      @onDeny="closeDeleteModal"
      )
        p {{ $t('generic.msg.confirmation') }}

</template>

<script>
  import { Goal} from '@/model/Goal'
  import { mapState, mapActions } from 'vuex'
  import _cloneDeep from 'lodash/cloneDeep'
  import CategoryTree from "@/component/category-tree"
  import Checkbox from '@/component/checkbox'
  import { mapDateUtils } from '@/utils/date-utils'
  import {CategoryTreeItemMode} from '@/component/category-tree/model'

  export default {
    name: 'GoalPopup',

    components: {
      CategoryTree,
      Checkbox
    },

    data () {
      return {
        PAGE_SHOW: false,
        goal: new Goal(),
        show_delete_modal: false,
        monthList: [],
        yearList: [],
        categoryTreeItemMode: CategoryTreeItemMode.CHECKBOX
      }
    },

    created () {
      this.monthList = this.getMonthList()
      this.yearList = this.getYearList()

      if (this.is_edit) {
        if (this.$route.params.goal) {
          this.goal = new Goal(_cloneDeep(this.$route.params.goal))
        } else {
          this.close()
        }
      }
      else {
        this.goal = new Goal({})
      }
    },

    computed: {

      ...mapState('Goal', [
        'goal_list'
      ]),

      ...mapState('Category', [
        'category_list'
      ]),

      categories() {
        return this.category_list.list.filter(item => item.is_expense)
      },

      is_edit () {
        return this.$route.name === 'goal-edit'
      },

      can_delete () {
        return this.is_edit
      },

      is_loading () {
        return this.$wait.is('createGoal')
      },
    },

    methods: {

      ...mapActions('Goal', [
        'createGoal',
        'deleteGoal'
      ]),

      ...mapDateUtils([
        'getMonthList',
        'getYearList'
      ]),

      onCategoryChange(value) {
        this.goal.category_ids = value
      },

      popupClose (event) {
        if (event.target.classList.contains('Popup')) {
          this.close()
        }
      },

      close (refresh) {
        this.$router.push({
          name: 'goal',
          params: {refresh}
        })
      },

      save () {
        this.$validator.validateAll().then(result => {
          if (!result) return

          if (!this.is_edit && this.goal_list.hasSameGoal(this.goal)) {
            this.showErrorToast('Seçilen ay ve yıl için bir hedef zaten mevcut!')
            return
          }

          this.createGoal({
            item: {
              ...this.goal
            },
            edit: this.is_edit
          })
          .then(() => {
            this.close(true)
          })
          .catch(err => {
            if (err.data.code && this.$tc(`error[${err.data.code}]`)) {
              return this.showErrorToast(this.$t(`error[${err.data.code}]`))
            }
            this.showErrorToast(JSON.stringify(err.data))
          })
        })
      },

      onDelete () {
        this.deleteGoal(this.goal.id).then(
          res => {
            this.close(true)
            this.showSuccessToast(this.$t('generic.msg.successful'))
          }
        ).catch(err => {
          if (err.data.code && this.$te(`error[${err.data.code}]`)) {
            return this.showErrorToast(this.$t(`error[${err.data.code}]`))
          }
          this.showErrorToast(JSON.stringify(err.data))
        })
      },

      openDeleteModal () {
        this.show_delete_modal = true
      },

      closeDeleteModal () {
        this.show_delete_modal = false
      }

    },

    beforeRouteEnter (to, from, next) {
      next(vm => {
        setTimeout(() => {
          vm.PAGE_SHOW = true
        }, 0)
      })
    },

    beforeRouteLeave (to, from, next) {
      this.PAGE_SHOW = false
      setTimeout(() => {
        next()
      }, 150)
    }

  }
</script>

<style lang="scss" scoped>

  .grid {
    display: grid;
    grid-column-gap: 40px;
    grid-row-gap: 22px;

    &-2-col {
      grid-template-columns: repeat(2, calc(50% - 20px));
    }
  }

  .left-padding {
    padding-left: 15px;
  }

  .goals {
    margin-top: 40px;

    .name, .total-goal, .role {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .total-goal {
      margin-left: 15px;
      margin-right: 15px;
    }
  }

  .type-list {
    margin-top: 20px;
  }

  .category-tree {
    label {
      opacity: 0.5;
    }
    .tree {
      border: 1px solid $color-shadow;
      border-radius: 4px;
      max-height: 40vh;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 0px;
        height: 10px;
      }

    }
  }
</style>

